const contactData = (contactInfo) => ({
  stackText: 'CONTACTO',
  titleText: 'Contáctanos',
  subtitleText: 'Estamos aquí para ayudarte',
  title: 'Información de contacto',
  description: 'Contáctanos, estaremos felices de escucharte. Construyamos juntos el próximo paso de tu negocio.',
  contactInfo: [
    {
      title: 'Dirección',
      description: contactInfo.address,
    },
    {
      title: 'Teléfono',
      description: contactInfo.phoneNumber,
    },
    {
      title: 'Correo electrónico',
      description: contactInfo.mail,
    },
  ],
  contactNameLabel: '¿Cuál es tu nombre?',
  contactEmailLabel: 'Email',
  contactPhoneLabel: 'Teléfono',
  contactQuestionLabel: 'Mensaje',
  buttonText: 'Enviar mensaje',
});

export default contactData;
